import { Component, HostBinding, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { MU_CHAT_CONFIG, MU_CHAT_DEFAULT_HEIGHT, MU_CHAT_DEFAULT_WIDTH } from '../../../sharedServices/mu-chat.config';
import { MuChatService } from '../../../sharedServices/mu-chat.service';

/** Configured size in px, or the default when the value is not a positive finite number. */
const toPx = (value: number, fallback: number): string => (Number.isFinite(value) && value > 0 ? value : fallback) + 'px';

/**
 * Presentational bare iframe for the ARENA chat. The URL stream comes from the chat service and the
 * size from the chat configuration; the widget draws its own chrome and failure states.
 */
@Component({
  selector: 'app-mu-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.sass'],
})
export class MuChatComponent {
  private readonly config = inject(MU_CHAT_CONFIG);

  readonly iframeUrl$: Observable<SafeResourceUrl | null> = inject(MuChatService).iframeUrl$;

  @HostBinding('style.--mu-chat-width') readonly width = toPx(this.config.width, MU_CHAT_DEFAULT_WIDTH);
  @HostBinding('style.--mu-chat-height') readonly height = toPx(this.config.height, MU_CHAT_DEFAULT_HEIGHT);
}
